import { defaultTo } from 'ramda';
import { IGetListForDesktopAppsResponseSchema } from '../../repositories/saved-searches/entities/get_list_for_desktop/GetListForDesktopAppsResponseSchema';
import { mapFrequency } from '../mapFrequency';
import { ISavedSearches } from '../../types/savedSearch';

export const mapSavedSearchesResponse = (response: IGetListForDesktopAppsResponseSchema): ISavedSearches => {
  return {
    count: response.total,
    isFetching: false,
    searches: defaultTo([], response.items).map(
      ({ address, description, frequency, id, link, newOffersCount, title, status }) => ({
        address,
        description,
        frequency: mapFrequency(frequency),
        id,
        link,
        newOffersCount,
        status,
        name: title,
        selectedFrequency: mapFrequency(frequency),
      }),
    ),
  };
};
